'use strict';

const {
	applySteerGtagPageContext,
	flushSteerExitIfLeftExperience,
	registerSteerHistoryTracking,
} = require('public/js/lib/steer-ga4');
const { registerSteerInboundListeners } = require('public/js/lib/steer-inbound');

registerSteerInboundListeners();
applySteerGtagPageContext();
registerSteerHistoryTracking();
flushSteerExitIfLeftExperience();
